<template>
  <v-select
    :items="fieldSelectItems"
    :label="fieldKey"
    :value="value"
    item-text="label"
    item-value="id"
    dense
    @input="handleOnInput"
    outlined
  >
  </v-select>
</template>

<script>
import { BaseFieldMixin } from './BaseFieldMixin'
import Enums from '@/helpers/Enums'
export default {
  name: 'SelectBoxSingleValueField',
  mixins: [BaseFieldMixin],
  props: {
    value: null,
    fieldType: {
      //overriding the setting from mixin
      type: String,
      required: false,
      default: () => {
        return Enums.FieldEditorType.selectBoxSingleValue
      }
    }
  },
  data: function() {
    return {}
  },
  created: function() {},
  methods: {
    handleOnInput: function(param) {
      console.log('SelectBoxSingleValueField', param)
      this.$emit('input', param)
    }
  }
}
</script>

<style scoped></style>
